<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs v-model:activeKey="activeKey" @change="changeTabs">
        <a-tab-pane :key="1" tab="经销商等级"></a-tab-pane>
        <a-tab-pane :key="2" tab="门店等级" force-render></a-tab-pane>
      </a-tabs>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='level' :columns='columns' :data-source='list'>
        <template v-slot:action="{ record }">
          <a v-has:onlinePriceAllSetEdit="()=>changeDiscount(record)" href="javascript:;">修改折扣率</a>
        </template>
      </a-table>
      <!-- <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" /> -->
    </a-card>
  </a-layout>
  <!-- 修改折扣 -->
  <a-modal v-model:visible="editDiscountVisible" centered style="width:700px" title="修改折扣率" :width="400" @ok="handleComfirm" :confirmLoading="confirmLoading">
      <a-form-item label="折扣率">
              <a-input-number v-model:value="discount.discount_rate_num" placeholder="请输入折扣率" :min="1" :max="100" :precision="0"></a-input-number> %
      </a-form-item>
  </a-modal>
</template>
<script>
import { ref, inject, onMounted } from "vue";
import { channelLevelDiscountRateDealer,channelLevelDiscountRateStore,editChannelLevelDiscountRateDealer,editChannelLevelDiscountRateStore } from "@/api/online";
import { iscode } from "@/utils/app";
import store from "@/store";
import useTableSearch from "@/hooks/useTableSearch";
import { message } from 'ant-design-vue';
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
};
export default {
  components: {
  },
  setup(props, ctx) {
    let columns = [
      {
        title: "级别",
        dataIndex: "level",
        key: "level",
      },
      {
        title: "级别名称",
        dataIndex: "level_name",
        key: "level_name"
      },
      {
        title: "折扣率",
        dataIndex: "discount_rate",
        key: "discount_rate"
      },
      {
        title: "操作",
        key: "action",
        width: 120,
        slots: { customRender: "action" },
      },
    ];
    const activeKey=ref(1)
    const $Modal = inject("$Modal");
    const {
      search,
      list,
      initData,
      listLoading,
    } = useTableSearch({ data: defSearch });
    const tableHoosks = {
      search,
      initData,
      list,
      listLoading,
    };
    onMounted(() => {
      tableHoosks.initData(channelLevelDiscountRateDealer, search.value);
    });
    const changeTabs = (e) => {
      search.value.page = 1;
      if (e == 1) {
        tableHoosks.initData(channelLevelDiscountRateDealer, search.value);
      } else {
        tableHoosks.initData(channelLevelDiscountRateStore, search.value);
      }
    };
    const editDiscountVisible=ref(false)
    const discount=ref({})
    const confirmLoading=ref(false)
    const changeDiscount=(data)=>{
      discount.value=JSON.parse(JSON.stringify(data))
      console.log(discount.value)
      editDiscountVisible.value=true
    }
    const handleComfirm=async()=>{
      if(isNaN(Number(discount.value.discount_rate))){
        message.error('请设置折扣率')
        return
      }
      confirmLoading.value=true
      var result;
      console.log(activeKey.value)
      if(activeKey.value==1){
        result=await editChannelLevelDiscountRateDealer(discount.value.level_id,discount.value).then(res=>res.data).catch(error=>error)
      }else{
        result=await editChannelLevelDiscountRateStore(discount.value.level_id,discount.value).then(res=>res.data).catch(error=>error)
      }
      confirmLoading.value=false
      editDiscountVisible.value=false
      if(iscode(result,true)){
        changeTabs(activeKey.value)
      }
    }
    return {
      info: store.state.user.info,
      ...tableHoosks,
      columns,
      changeTabs,
      discount,
      changeDiscount,
      editDiscountVisible,
      handleComfirm,
      activeKey,
      confirmLoading
    };
  },
};
</script>